import React from "react";
import { Table, Card, Button, Typography, Tag } from "antd";
import { useQuery } from "react-query";
import { getAll as getInvoices } from "../../../services/invoices.service";
import { formatCurrency } from "../../../services/utils";
import moment from "moment";

const { Title } = Typography;

export default function OverdueList({ params }: { params?: any }) {
  // Fetch pending invoices, ordered by due_date ascending (oldest first)
  const { data, isLoading } = useQuery(
    ["getOverdueSales", params],
    () =>
      getInvoices({
        status: "Pending",
        order: "due_date-asc",
        limit: 10,
        customer_id: params?.customer_id,
        periodDueDate:
          params.start_date && params.end_date
            ? `${params.start_date}, ${params.end_date}`
            : undefined,
      }),
    {
      refetchOnWindowFocus: false,
    }
  );

  const invoices = data?.data || [];

  // Filter for overdue items and calculate days
  const overdueItems = invoices
    .map((sale: any) => {
      const data = sale.data; // Sales service usually returns { data: { ...attributes } }
      const dueDate = moment(data.due_date);
      const today = moment().startOf("day");
      const daysOverdue = today.diff(dueDate, "days");

      return {
        id: data.id,
        customer_name: data?.customer?.name || "Cliente", // Assuming relationship or name availability
        value: data.total_amount || 0, // Adjust based on sale structure
        due_date: data.due_date,
        days_overdue: daysOverdue,
        key: data.id,
      };
    })
    .filter((item: any) => item.days_overdue > 0)
    .slice(0, 5);

  const columns = [
    {
      title: "Cliente",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
      title: "Valor",
      dataIndex: "value",
      key: "value",
      render: (value: number) => formatCurrency(Number(value || 0)),
    },
    {
      title: "Vencimento",
      dataIndex: "due_date",
      key: "due_date",
      render: (date: string) => moment(date).format("DD/MM/YYYY"),
    },
    {
      title: "Dias em Atraso",
      dataIndex: "days_overdue",
      key: "days_overdue",
      render: (days: number) => <Tag color="red">{days} dias</Tag>,
    },
  ];

  return (
    <Card
      title={<Title level={5}>Últimas Cobranças em Atraso</Title>}
      extra={
        <Button type="link" href="/sales">
          Ver todas as cobranças
        </Button>
      }
      bordered={false}
    >
      <Table
        dataSource={overdueItems}
        columns={columns}
        loading={isLoading}
        pagination={false}
        rowKey="id"
        locale={{ emptyText: "Nenhuma cobrança em atraso" }}
      />
    </Card>
  );
}
